// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__rKcZk","tab":"ProcedureTabs_tab__3LM9-"};